/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import './softwareCost.scss';
import MagnifyingGlass from '../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import ButtonComponent from '../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '../../../Assets/images/svg/dar_pencil.svg';
import { TextField } from '@mui/material';
import { formatCurrency} from '../costMasterUtils';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import UseAxios from '../../../Api/http/http';
import { getSoftwareCost,saveSoftwareCost, updateSoftwareCost, getCloudCost } from '../../../Api/request/costMaster';
import { v4 as uuidv4 } from 'uuid';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';

const SoftwareCost = () => {
  const [softwareCostRows, setSoftwareCostRows] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.MASTER_COST_MASTER] || []
  : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const [operationType, setOperationType] = useState('insert');
  const [currencies, setCurrencies] = useState([]);
  const [units, setUnits] = useState([]);
  const { snackbarOpen } = useSnackbar();

  useEffect(() => {
    checkMobileView();
    fetchDropdownData();
    fetchSoftwareCostDetails();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [softwareCostRows]);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1024);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };
  const fetchDropdownData = async () => {
    try {
      const response = await UseAxios(getCloudCost());
      const { currencies, units } = response.data.data;
      setCurrencies(currencies);
      setUnits(units);
    } catch (error) {
      console.error('Error fetching dropdown data:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };
  const fetchSoftwareCostDetails = async () => {
    try {
      const response = await UseAxios(getSoftwareCost());
      const transformedData = response?.data?.map((item, index) => ({
        id: item.id,
        srNo: index + 1,
        software: item.software,
        unit: item.unit,
        cost: item.cost,
        currency: item.currency,
        softwareRemarks: item.remark,
        isEditing: false, 
      }));
  
      setSoftwareCostRows(transformedData);
    } catch (error) {
      console.error('Error fetching cloud cost details:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  const handleAddRow = () => {
    const defaultCurrency = 'USD';
    const defaultCurrencyId = getFieldIdValue('currency', defaultCurrency);
    const newRow = {
      id: uuidv4(),
      checkbox: false,
      srNo:softwareCostRows.length + 1,
      software: '',
      cost: '',
      unit: '',
      currency: defaultCurrency,
      currencyId: defaultCurrencyId,
      softwareRemarks: '',
      isEditing: true,
      rowHeight: 120,
    };
    const updatedRows = [newRow, ...softwareCostRows].map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));
    setSoftwareCostRows(updatedRows);
    setOperationType('insert');
  };
  const getFieldIdValue = (field, value) => {
    switch (field) {
      case 'unit':
        return units.find((unit) => unit.name === value)?.id || null;
      case 'currency':
        return currencies.find((currency) => currency.name === value)?.id || null;
      default:
        return value;
    }
  };
  const handleSoftwareInputChange = (e, id, field) => {
    const value = e.target.value?.name || e.target.value;
    setSoftwareCostRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          const fieldIdValue = getFieldIdValue(field, value); 
          return {
            ...row,
            [field]: value,
            [`${field}Id`]: fieldIdValue, 
          };
        }
        return row;
      })
    );
  };
  
  

  const handleSave = (id) => {
      const rowToSave = softwareCostRows.find((row) => row.id === id);
      saveRow(rowToSave, operationType);
  };
  
  const saveRow = async (rowToSave, operationType) => {
    const id = rowToSave.id;

    const payload = {
      software: rowToSave.software,
      unit: rowToSave.unitId,
      cost: rowToSave.cost,
      currency: rowToSave.currencyId,
      remark: rowToSave.softwareRemarks,
    };
    if (operationType === 'insert') {
      try {
        await UseAxios(saveSoftwareCost(payload));
        snackbarOpen('Data saved successfully', 'success');
      } catch (error) {
        console.error('Error saving row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;
      }
    }
    else if (operationType === 'update') {
      try {
        payload.id = id;
        await UseAxios(updateSoftwareCost(payload));
        snackbarOpen('Data updated successfully', 'success');
      } catch (error) {
        console.error('Error updating row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;        
      }
    }
    setSoftwareCostRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowToSave.id ? { ...row, isEditing: false } : row
      )
    );
    fetchSoftwareCostDetails();
  }

  const handleCancel = (id) => {
    setSoftwareCostRows((prevRows) =>
      prevRows.some((row) => row.isEdit)
        ? 
          prevRows.map((row) =>
            row.id === id
              ? { ...row.originalData, isEditing: false, isEdit: false }
              : row
          )
          .filter((row) => row.id) // Ensure all rows have an `id`
          .map((row, index) => ({
           ...row,
           srNo: index + 1,
          }))
        : 
          prevRows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
              ...row,
              srNo: index + 1, 
            }))
    );
  };

  const handleEdit = (id) => {
    setOperationType('update');
    setSoftwareCostRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, isEditing: true, isEdit: true, originalData: { ...row } } : row))
    );
  };

  const getSelectedValue = (name, options) => {
    return options.find(option => option.name === name) || null;
  };

  const newSoftwareRow = {
    software: '',
    cost: '',
    unit: '',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newSoftwareRow).some((key) => row[key] === newSoftwareRow[key]);
  };

  const columns = [
    {
      field: 'srNo',
      headerName: 'Sr.No.',
      width: isMobileView ? 90 : undefined,
      flex: !isMobileView ? 0.2 : undefined,
      minWidth: 145,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'software',
      headerName: 'Software',
      width: isMobileView ? 220 : undefined,
      sortable: false,
      flex: !isMobileView ? 0.8 : undefined,
      minWidth: 165,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              defaultValue={row.software}
              onChange={(e) => handleSoftwareInputChange(e, row.id, "software")}
              onKeyDown={(e) => e.stopPropagation()}
              className='text-box-css input'
              variant="outlined"
              size="small"
            />
          </div>
        ) : (
            <label className="saved-value">{row.software}</label>
        ),
    },
    {
      field: 'cost',
      headerName: 'Cost',
      width: isMobileView ? 200 : undefined,
      flex: !isMobileView ? 0.75 : undefined,
      minWidth: 150,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'softwareCost-header',
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', alignItems: 'center' }} className="number-input-div">
            <SearchDropdown
              searchBox={false}
              placeholder="Select"
              options={currencies}
              onChange={(e) => handleSoftwareInputChange(e, row.id, 'currency')}
              value={getSelectedValue(row.currency, currencies)}
              dropdownCss="currency-select"
            />
            <TextField
              defaultValue={row.cost}
              onChange={(e) => handleSoftwareInputChange(e, row.id, 'cost')}
              onKeyDown={(e) => e.stopPropagation()}
              className="number-input"
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
              }}
            />
          </div>
        ) : (
          <label className="saved-value softwareCost-cell">
            {formatCurrency(row.cost, row.currency)}
          </label>
        ),
    },
    {
      field: 'unit',
      headerName: 'Unit',
      flex: !isMobileView ? 0.75 : undefined,
      width: isMobileView ? 210 : undefined,
      minWidth: 135,
      sortable: false,
      disableColumnMenu: true,

      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={units}
              onChange={(e) => handleSoftwareInputChange(e, row.id, 'unit')}
              value={getSelectedValue(row.unit, units)}
              dropdownCss="text-box-css"
            />
          </div>
        ) : (
          <label className="saved-value">{row.unit}</label>
        ),
    },

    {
      field: 'softwareRemarks',
      headerName: 'Remarks',
      flex: !isMobileView ? 0.8 : undefined,
      width: isMobileView ? 300 : undefined,
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
            defaultValue={row.softwareRemarks}
            onChange={(e) => handleSoftwareInputChange(e, row.id, "softwareRemarks")}
            onKeyDown={(e) => e.stopPropagation()}
            className='text-box-css input'
            variant="outlined"
            size="small"
          />
        ) : (
          <label className="saved-value">{row.softwareRemarks && row.softwareRemarks.trim() !== ''
            ? row.softwareRemarks
            : '-'}</label>
        ),
    },

    {
      width: isMobileView ? 60 : undefined,
      flex: !isMobileView ? 0.25 : undefined,
      minWidth: 60,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: ({ row }) => (
        <div className="mobile-action-icons">
        {!row?.isEditing ? (                  
          <button
            className="role-action-edit-icon"
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
              opacity: hasAccess('update') ? 1 : 0.5, 
            }}
            onClick={() => handleEdit(row.id)}
            disabled={!hasAccess('update')}
            
          >
            <img src={EditIcon} alt="Edit" />
          </button>
       ):(
        <div className='save-and-cancel-button-main' style={{ paddingTop: isMobileView ? '0px' : '4px' }}>
          <button
            className='save-and-cancel-button save-button-tick-placing'
            style={{
              backgroundColor: isRowUnchanged(row) ? '#a69df1' : '#6B5CE8', 
              color: '#ffff',
            }}
            disabled={isRowUnchanged(row)}
            onClick={() => handleSave(row.id)}
          >✔</button>
          <button
            className='save-and-cancel-button save-button-cross-placing'
            style={{
              backgroundColor: 'transparent',
              color: '#6B5CE8',
              border: '1px solid #6B5CE8'
            }}
            onClick={() => handleCancel(row.id)}
          >X</button>
        </div>
       )}
        </div>
      ),

      disableColumnMenu: true,
      sortable: false,
      
    },
  ];

  const filteredSoftwareRows = searchText
    ? softwareCostRows.filter((row) =>
        Object.values(row).some((value) =>
          (value ? value.toString() : '').toLowerCase().includes(searchText)
        )
      )
    :softwareCostRows;

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
  ];
  const rowHeightCondition = (params) => {
    const row = softwareCostRows.find((row) => row.id === params.id);
    const isOtherSelected = row?.isEditing && (row?.Software === 'Other' || row?.unit === 'Other');
    
    let height;
  
    if (isOtherSelected) {
      height = 150;
    } else if (row?.isEditing) {
      height = 110;
    } else {
      height = 52;
    }
  
    return height;
  };
  


  return (
    <div className="software-cost-outer-layer">
      <div className="software-cost-map">
        <div
          className="software-cost-search-and-buttons"
          style={{ marginBottom: '20px' }}
        >
          <div className="software-cost-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="software-cost-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="software-cost-container">
          <div className="software-cost-header">
            <div className="software-cost-title">Software Cost</div>

            <div className="software-cost-buttons">
            <div className="software-cost-filter-and-add-button">
              <ButtonComponent
                variant="contained"
                label="Add"
                onClick={handleAddRow}
                startIcon={<AddIcon />}
                disabled={!hasAccess('create')}
              />
            </div>
          </div>
          </div>
          <div className="data-grid-container">
            <DataGridComponent
              dataRows={filteredSoftwareRows}
              dataColumns={columns}
              isDealTransition={true}
              isFilteredRows={filteredSoftwareRows}
              pageSize={10}
              sortFilterColumns={sortFilterColumns}
              isEdit={isEdit}
              gridCheckbox={false}
              onRowSelectionChange={() => {}}
              dataGridCss=""
              checkboxDisabled={false}
              rowHeightCondition={rowHeightCondition}

            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SoftwareCost;
